
<div #pictureEditor class="picture-editor" cdkDropListGroup>
    
  <div class="picture-list" cdkDropList [cdkDropListData]="['' + i]" cdkDropListOrientation="horizontal" (cdkDropListDropped)="drop($event)" *ngFor="let list of lists; let i = index">
    <div cdkDrag *ngFor="let picture of list;" [class.warning]="hasWarning(picture)" [matTooltip]="getSmallPictureTooltip(picture)" class="picture-box picture">
      <img [src]="picturesUrl + '/' + picture.key" (load)="checkLoadedPicture($event, picture)">
      <button (click)="delete(picture.key)"
          *ngIf="maxImages > 1"
          type="button"  
          mat-mini-fab 
          color="accent"
          angulartics2On="click" 
          angularticsAction="Button Pressed"
          angularticsCategory="Picture list editor"
          angularticsLabel="delete picture"
          [angularticsProperties]="{'pictureKey': picture.key}" >
        <mat-icon fontSet="material-symbols-outlined">delete</mat-icon>
      </button>
      <button *ngIf="maxImages <= 1 && !uploading"
          mat-mini-fab
          type="button"   
          color="accent"
          angulartics2On="click" 
          angularticsAction="Button Pressed"
          angularticsCategory="Picture list editor"
          angularticsLabel="edit picture"
          [angularticsProperties]="{'pictureKey': picture.key}">
        <mat-icon fontSet="material-symbols-outlined">edit</mat-icon>
      </button>
      <mat-icon fontSet="material-symbols-outlined" *ngIf="hasWarning(picture)" class="warning-icon filled-icon">warning</mat-icon>
      <input type="file"
          (change)="selectFile($any($event.target).files, true)"
          *ngIf="maxImages <= 1 && !uploading"  
          accept="image/jpeg, image/png, image/webp, application/vnd.lotus-1-2-3"
          angulartics2On="click" 
          angularticsAction="Button Pressed"
          angularticsCategory="Picture list editor"
          angularticsLabel="add picture">
      <mat-progress-spinner class="spinner" *ngIf="maxImages <= 1 && uploading" mode="indeterminate" color="accent"></mat-progress-spinner>
      <caption *ngIf="hasWarning(picture)" class="too-small" i18n>Revise image?</caption>
    </div>
    <div *ngIf="pictures.length < maxImages && i === lists.length - 1 && list.length < picturesPerRow" class="add-picture-button">
      <div class="picture-box" style="background-color: white;">
        <button type="button" mat-fab color="accent" *ngIf="!uploading">
          <mat-icon fontSet="material-symbols-outlined">add_a_photo</mat-icon>
        </button>
        <input type="file"
            (change)="selectFile($any($event.target).files)"
            *ngIf="!uploading"  
            accept="image/jpeg, image/png, image/webp, application/vnd.lotus-1-2-3"
            [attr.multiple]="maxImages > 1 ? true : null"
            angulartics2On="click" 
            angularticsAction="Button Pressed"
            angularticsCategory="Picture list editor"
            angularticsLabel="add picture">
        <mat-progress-spinner class="spinner" *ngIf="uploading" mode="indeterminate" color="accent"></mat-progress-spinner>
      </div>
    </div>
  </div>
  <div *ngIf="shouldShowButtonInTheEnd" class="add-picture-button">
    <div class="picture-box" style="background-color: white;">
      <button type="button" mat-fab color="accent" *ngIf="!uploading">
        <mat-icon fontSet="material-symbols-outlined">add_a_photo</mat-icon>
      </button>
      <input type="file"
          (change)="selectFile($any($event.target).files)"
          *ngIf="!uploading"
          accept="image/jpeg, image/png, image/webp, application/vnd.lotus-1-2-3"
          [attr.multiple]="maxImages > 1 ? true : null"
          angulartics2On="click" 
          angularticsAction="Button Pressed"
          angularticsCategory="Picture list editor"
          angularticsLabel="add picture">
      <mat-progress-spinner class="spinner" *ngIf="uploading" mode="indeterminate" color="accent"></mat-progress-spinner>
    </div>
  </div>
</div>
